import { useMutation, useQueryClient } from "@tanstack/react-query";
import { removeReminderFromListCaches } from "web_myplann/Api/Reminders/remindersCacheUtils";
import { deleteRemindersIdV2 } from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

export const useReminderDeleteMutation = () => {
	const queryClient = useQueryClient();

	return useMutation<void, Error, string>({
		mutationFn: processResponse((id: string) =>
			deleteRemindersIdV2(Number(id)),
		),
		onSuccess: (_data, id) => {
			removeReminderFromListCaches(queryClient, Number(id));
		},
	});
};
